import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const ZoomX = [
  "/warehouse-config/create-warehouse-out-ward",
  "/warehouse-config/edit-warehouse-out-ward,",
  "/warehouse-config/edit-warehouse-in-ward",
  "/warehouse-config/detail-warehouse-out-ward",
  "/warehouse-config/create-warehouse-in-ward",
  "/warehouse-config/edit-warehouse-out-ward",
  "/warehouse-config/detail-warehouse-in-ward",
];

const ClearSearchKeyOnLeaveHome = () => {
  const location = useLocation();
  const handleRouteChanges = [
    //xuất kho
    "/warehouse-config/warehouse-out-ward",
    "/warehouse-config/create-warehouse-out-ward",
    "/warehouse-config/edit-warehouse-out-ward,",
    "/warehouse-config/detail-warehouse-out-ward",
    //Nhập kho
    "/warehouse-config/warehouse-in-ward",
    "/warehouse-config/create-warehouse-in-ward",
    "/warehouse-config/edit-warehouse-in-ward",
    "/warehouse-config/detail-warehouse-in-ward",
    //Danh sách đơn
    "/sell/sales-order-list",
    "/sell/view-order-return",
    "/sell/view-order",
    "/sell/sales-order-list-read-only",
    "/sell/payment-order",
    "/sell/retail-order",
    "/sell/payment-order-return",
    "/sell/approved-discount-order",
    "/sell/revise-order",
    //Thu chi
    "/bill/list-receipts",
    "/bill/detail-payment-receipt",
    "/bill/payment-receipt",
    "/bill/order-confirmation",
    "/bill/internal-receipt",
    "/bill/payment-slip-branches",
    "/bill/credit-advice",
    "/bill/debt-note-branches",
    "/bill/adjustment-slip",
    //Yêu cầu điều chuyển
    "/warehouse-config/request-transfer",
    "/warehouse-config/request-inventory-transaction",
    "/warehouse-config/detail-request-transfer",
  ];

  useEffect(() => {
    const handleRouteChange = () => {
      if (!handleRouteChanges.includes(location.pathname)) {
        localStorage.removeItem("allValueKeySearch");
      }
    };
    handleRouteChange();
  }, [location.pathname]);

  return null;
};

export default ClearSearchKeyOnLeaveHome;
